import { offlineStore } from './offlineStore';

const listeners = new Set();
let _status = { state: 'synced', pending: 0, errors: 0 };

export function subscribeSyncStatus(fn) {
  listeners.add(fn);
  fn({ ..._status });
  return () => listeners.delete(fn);
}

function emit(update) {
  _status = { ..._status, ...update };
  listeners.forEach(fn => fn({ ..._status }));
}

export async function enqueue(mutation) {
  try {
    await offlineStore.put('sync_queue', {
      ...mutation,
      status: 'pending',
      createdAt: new Date().toISOString(),
      retries: 0,
    });
    await refreshSyncStatus();
  } catch (e) {
    console.warn('syncQueue.enqueue failed', e);
  }
}

export async function refreshSyncStatus() {
  try {
    const all = await offlineStore.getAll('sync_queue');
    const pending = all.filter(e => e.status === 'pending').length;
    const errors  = all.filter(e => e.status === 'error').length;
    const state   = !navigator.onLine ? 'offline'
      : errors > 0 ? 'error'
      : pending > 0 ? 'pending'
      : 'synced';
    emit({ state, pending, errors });
  } catch {}
}

export function getSyncStatus() {
  return { ..._status };
}

// Placeholder — replace with real API calls when backend exists
async function processPending() {
  const all = await offlineStore.getAll('sync_queue');
  const pending = all.filter(e => e.status === 'pending');
  if (!pending.length) return;
  // No-op: local-first, no backend yet
  // When backend added: for each mutation, POST to API, then offlineStore.delete('sync_queue', entry.qid)
}

window.addEventListener('online',  () => { emit({ state: 'pending' }); processPending().then(refreshSyncStatus); });
window.addEventListener('offline', () => emit({ state: 'offline' }));
